import { converterType } from "@dcc/types/converterType";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";

const MONTHLY_UNITS_FACTOR = 4.25;
const MONTHLY_TOTALDRINKS_FACTOR = 4;

export const monthlyUnitAndCaloriesConverter: (
  numberOfMonthlyDays: number
) => converterType = (numberOfMonthlyDays: number) => ({
  [DrinkFrequency.Never]: (value: number) => value,
  [DrinkFrequency.Weekly]: (value: number) => value,
  [DrinkFrequency.Monthly]: (value: number) => value / MONTHLY_UNITS_FACTOR,
  [DrinkFrequency.TwiceMonthly]: (value: number) =>
    (numberOfMonthlyDays * value) / MONTHLY_UNITS_FACTOR
});

export const monthlyTotalDrinksConverter: (
  numberOfMonthlyDays: number
) => converterType = (numberOfMonthlyDays: number) => ({
  [DrinkFrequency.Never]: (value: number) => value,
  [DrinkFrequency.Weekly]: (value: number) => value,
  [DrinkFrequency.Monthly]: (value: number) =>
    value / MONTHLY_TOTALDRINKS_FACTOR,
  [DrinkFrequency.TwiceMonthly]: (value: number) =>
    (numberOfMonthlyDays * value) / MONTHLY_TOTALDRINKS_FACTOR
});
